import PropTypes from 'prop-types'

import { STRING } from 'resources'

import formatPoints from 'utils/format-points'
import getDecimalValue from 'utils/get-decimal-value'

import RedemptionSelection from './RedemptionSelection'

import {
  RewardContainer,
  RewardDescription,
  RewardImage,
  RewardName,
  RewardRedemptionValues,
  RewardDescriptionTitle,
  RewardContent,
  RewardDescriptionText,
  RewardImageContainer,
} from './styles'

const RedeemReward = ({ reward }) => {
  const minValue = getDecimalValue(reward.redemptionValues[0])

  let description = ''
  if (reward.minShares) {
    description = `${reward.minShares}+ shares`
  } else if (reward.redemptionValues.length === 1) {
    description = STRING.wallet.rewards.redemptionSingle(formatPoints(minValue))
  } else {
    const maxValue = reward.redemptionValues[reward.redemptionValues.length - 1]
    description = STRING.wallet.rewards.redemptionRange(formatPoints(minValue), formatPoints(maxValue, true))
  }

  return (
    <RewardContainer>
      <RewardImageContainer>
        <RewardImage src={reward.imageUrl} />
      </RewardImageContainer>
      <RewardName>{reward.name}</RewardName>
      <RewardRedemptionValues>{description}</RewardRedemptionValues>
      <RewardContent>
        {!!reward.description && (
          <RewardDescription>
            <RewardDescriptionTitle>{STRING.wallet.rewards.description}</RewardDescriptionTitle>
            <RewardDescriptionText>{reward.description}</RewardDescriptionText>
          </RewardDescription>
        )}
        <RedemptionSelection reward={reward} />
      </RewardContent>
    </RewardContainer>
  )
}

RedeemReward.propTypes = {
  reward: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string,
    categoryId: PropTypes.string.isRequired,
    isTop: PropTypes.bool.isRequired,
    imageUrl: PropTypes.string.isRequired,
    redemptionValues: PropTypes.arrayOf(PropTypes.string).isRequired,
    currentPrice: PropTypes.string,
    dayChange: PropTypes.string,
    minShares: PropTypes.number,
    sharePrice: PropTypes.string,
  }).isRequired,
}

export default RedeemReward
